<template>
  <m-c104 :product="item" class="slider-card archive-product" />
</template>

<script>
export default {
  name: "CategoryCard",
  props: ['item']
}
</script>


<style>
.archive-product .price-now {
  color: var(--dark) !important;
}
</style>

<style scoped>
.slider-card{
  max-height: 500px !important;
  width: 255px;
}
</style>